const STYLES = {
  success: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  partial: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  error: "bg-red-500/10 text-red-400 border-red-500/30",
  cron: "bg-violet-500/10 text-violet-300 border-violet-500/30",
  manual: "bg-cyan-500/10 text-cyan-300 border-cyan-500/30",
};

export const StatusBadge = ({ value, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center px-2 py-0.5 rounded border font-mono text-[11px] uppercase tracking-wider ${STYLES[value] || "border-slate-700 text-slate-400"}`}>
    {value}
  </span>
);
